import { DetailedItemValue } from '../types';
import { fromMonetaryAmountString } from '../../../helpers/formatters';

export const itemsVatAmountExp = (items: DetailedItemValue[], lng: string, currency: string) => {
    return parseFloat(items.reduce((acc, item) => {
        const itemAmountWithVat = fromMonetaryAmountString(lng, item.amount, currency) * parseInt(item.quantity);
        if (itemAmountWithVat === 0) {
            return 0;
        }
        return acc + vatAmount(itemAmountWithVat, parseFloat(item.vat));
    }, 0).toFixed(0));
};

export const vatAmount = (amount: number, vatPercentage: number) => {
    return Math.ceil(amount - (amount / ((vatPercentage / 100) + 1)));
};
